import { useTranslation } from 'react-i18next';
import { notificationService } from '@/lib/services/notification.service';
import { logger } from '@/lib/utils/logger';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { deleteMcpCatalog } from '../../api/mcp-catalog.api';
import { ADMIN_QUERY_KEYS } from '../../api';

export const useDeleteCatalogMcp = () => {
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string }) => deleteMcpCatalog(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ADMIN_QUERY_KEYS.mcpCatalog.available });
      // Catalog edits also surface in the user-facing MCP views (My MCPs + chat composer), which
      // read a separate `['user-mcps', …]` query namespace. Admin must not import the
      // user-mcp-servers feature (FSD boundary), so invalidate by its stable root prefix.
      await queryClient.invalidateQueries({ queryKey: ['user-mcps'] });
      notificationService.showSuccess(t('admin.useDeleteCatalogMcp.mcpServerRemovedFromThe'));
    },
    onError: (error) => {
      notificationService.showError(t('admin.useDeleteCatalogMcp.failedToRemoveMcpServerFrom'));
      logger.error('Failed to delete catalog MCP:', error);
    },
  });
};
